/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CheckCurvyOutlinedSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CheckCurvyOutlinedSmall',
      'aria-hidden': true,
      focusable: false,
      width:  13 * scale,
      height: 12 * scale,
      viewBox: '0 0 13 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"#000","d":"M11.4 0c-.2 0-.4.1-.6.2-2.5 1.7-4 3.1-6 5.2C4 4.8 3.3 4.5 2.4 4c-.1 0-.3-.1-.4-.1-.3 0-.5.1-.7.3l-.9.9c-.2.2-.3.4-.3.7s.1.5.3.7l.7-.7-.7.7C2.2 8.2 3.2 9.3 4.7 11c.2.2.5.4.8.4h.1c.3 0 .6-.2.8-.5 2.4-4 4.4-6.4 6.4-8.6.4-.4.4-1 0-1.4l-.6-.7c-.3-.1-.5-.2-.8-.2","opacity":".3"}),createElement('path', {"fill":"currentColor","d":"m1.1 5.8.9-.9c1.1.5 1.8.9 3 1.8C7.3 4.3 8.7 2.8 11.4 1l.6.7c-2.1 2.2-4.1 4.7-6.6 8.8-1.5-1.8-2.5-3-4.3-4.7"}))
}
